/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import React from 'react'
import { RouteComponentProps, NavLink, Route } from 'react-router-dom'
import { FaRegThumbsUp, FaRegThumbsDown, FaThumbsUp, FaThumbsDown } from 'react-icons/fa'
import { observer } from 'mobx-react'
import { container } from '../../configuration/ServiceLocator'
import { UserVote, IArticle, IArticleRating, IContentStateManager } from '../../services/ContentStateManager/contracts'
import ReactHtmlParser, { convertNodeToElement, processNodes } from 'react-html-parser'
import './Content.scss'
import moment from 'moment'
import { Breadcrumb, BreadcrumbItem } from 'reactstrap'
import UnderConstruction from '../../img/DdeClaimActivityAnalysisIndex.png'
import { SettingsManager } from '../../configuration/SettingsManager'
import ReactGA from 'react-ga4'
import { UserEventLogger } from '../../utils/UserEventLogger'

export interface IContentProps extends RouteComponentProps<any> {
	contentStateManager: IContentStateManager
	path: string
}

interface IContentState {
	article: IArticle
	rating: IArticleRating
	underConst: number
}

@observer
export class Content extends React.Component<any, IContentState> {
	stateManager: IContentStateManager
	path: string
	userId: string
	contentDidUpdate: number

	constructor(props: Readonly<IContentProps>) {
		super(props)
		this.userId = ''
		this.contentDidUpdate = 0
		this.stateManager = props.contentStateManager
		this.path = props.location.pathname.slice(props.match.path.indexOf(':'))
		this.stateManager
			.getUserId()
			.then(id => (this.userId = id))
			.catch(error => {
				console.error(error)
			})

		this.state = {
			underConst: 0,
			article: { contentItemId: '', path: '', displayText: '', publishedUtc: new Date(), markup: '' },
			rating: { contentItemId: '', countLikes: 0, countDislikes: 0, vote: UserVote.none },
		} as IContentState
		this.likeArticle = this.likeArticle.bind(this)
		this.dislikeArticle = this.dislikeArticle.bind(this)
	}
	componentDidUpdate() {
		if (this.contentDidUpdate === 0) {
			if ($('.helpContent').length) {
				const imges = $('.helpContent').find('img')
				if (imges.length > 0) {
					imges.each(function() {
						const src = $(this).attr('src') as string
						if (!src.includes(SettingsManager.REACT_APP_MAIN_CMS_BASE_URL().value)) {
							$(this).attr('src', SettingsManager.REACT_APP_MAIN_CMS_BASE_URL().value + src)
						}
					})
				}
				$('table').each(function() {
					const curTable = $(this)
					if ($(this).find('tr').length == 1) {
						const th = $(this).find('tr:first th:first')
						$(th).css({
							'background-color': 'transparent',
							color: '#60605b',
							'vertical-align': 'top',
							'font-weight': 'bold',
						})
					}
					if ($(this).find('tr').length > 1) {
						const tr = $(this).find('tr:first')
						$(tr).css({
							'background-color': '#003D79',
						})
						$(this)
							.find('tr')
							.each(function(i, row) {
								const thAlign = $(row).find('th')
								$(thAlign).css({
									'vertical-align': 'top',
									color: '#60605b',
									'font-weight': 'bold',
								})
							})
					}
				})
			}
			this.contentDidUpdate = 1
		}
	}
	componentDidMount(): void {
		this.stateManager
			.getArticle(this.path)
			.catch(error => {
				// display user friendly error message
				console.log(error)
				this.setState({ underConst: 2 })
			})
			.then(response => {
				const article = response as IArticle
				this.stateManager
					.getArticleRating(article.contentItemId, this.userId)
					.then(response => {
						this.setState({ rating: response, article: article, underConst: 1 })
					})
					.catch(error => {
						console.log(error)
						this.setState({ underConst: 2 })
					})
			})
	}

	likeButton(): any {
		if (this.state.rating.vote === UserVote.like) {
			return (
				<button onClick={e => this.likeArticle(e)} className="button-border-radious">
					<FaThumbsUp />
				</button>
			)
		} else {
			return (
				<button onClick={e => this.likeArticle(e)} className="button-border-radious">
					<FaRegThumbsUp />
				</button>
			)
		}
	}

	dislikeButton(): any {
		if (this.state.rating.vote === UserVote.dislike) {
			return (
				<button onClick={e => this.dislikeArticle(e)} className="button-border-radious">
					<FaThumbsDown />
				</button>
			)
		} else {
			return (
				<button onClick={e => this.dislikeArticle(e)} className="button-border-radious">
					<FaRegThumbsDown />
				</button>
			)
		}
	}

	productBreadCrumb(): any {
		if (this.state.article.productName !== '') {
			return (
				<BreadcrumbItem>
					<a href={'/supportsite/pages/product/' + this.state.article.productCode + '/' + this.state.article.productName} onClick={this.handleBreadCrumbClick}>
						{this.state.article.productName}
					</a>
				</BreadcrumbItem>
			)
		} else {
			return null
		}
	}

	sectionBreadCrumb(): any {
		if (this.state.article.sectionName !== '') {
			return (
				<BreadcrumbItem>
					<a href={'/supportsite/pages/product/' + this.state.article.productCode + '/' + this.state.article.productName + '/sectionid/' + this.state.article.sectionId + '/sectionName/' + this.state.article.sectionName} onClick={this.handleBreadCrumbClick}>
						{this.state.article.sectionName}
					</a>
				</BreadcrumbItem>
			)
		} else {
			return null
		}
	}

	ratingText(): any {
		const total = this.state.rating.countDislikes + this.state.rating.countLikes
		return total > 0 ? `${this.state.rating.countLikes} out of ${total} found this helpful.` : ''
	}

	likeArticle(event: any): void {
		// Click the like button to like it, click it twice to remove the "like" vote
		this.handleArticleYesOrNoIconClick(event, true)
		const newVote = this.state.rating.vote === UserVote.like ? UserVote.none : UserVote.like
		this.stateManager
			.voteOnArticle(this.state.article.contentItemId, this.userId, newVote, this.state.rating.vote)
			.then(rating => this.setState({ rating: rating }))
			.catch(error => {
				console.log(error)
			})
	}

	dislikeArticle(event: any): void {
		// Click the dislike button to dislike it, click it twice to remove the "dislike" vote
		this.handleArticleYesOrNoIconClick(event, false)
		const newVote = this.state.rating.vote === UserVote.dislike ? UserVote.none : UserVote.dislike
		this.stateManager
			.voteOnArticle(this.state.article.contentItemId, this.userId, newVote, this.state.rating.vote)
			.then(rating => this.setState({ rating: rating }))
			.catch(error => {
				console.log(error)
			})
	}

	handleArticleYesOrNoIconClick(event: any, likeClicked: boolean) {
		UserEventLogger.handleUserClickEvent(event, 'SupportSite - Content Page Article helpful Yes or No icon Click', likeClicked ? 'Yes' : 'No')
	}

	handleBreadCrumbClick(event: any) {
		UserEventLogger.handleUserClickEvent(event, 'SupportSite - Content Page BreadCrumb Click', '')
	}

	render() {
		return (
			<div className="main-div-pad-btm">
				{this.state.underConst == 0 ? (
					''
				) : this.state.underConst == 1 && this.state.article.contentItemId ? (
					<div>
						<div>
							<Breadcrumb>
								<BreadcrumbItem>
									<a href="/supportsite/pages/landingpage" onClick={this.handleBreadCrumbClick}>
										Support Home
									</a>
								</BreadcrumbItem>
								{this.productBreadCrumb()}
								{this.sectionBreadCrumb()}
								<BreadcrumbItem active>{this.state.article.displayText}</BreadcrumbItem>
							</Breadcrumb>
						</div>

						<div>Last Updated: {moment(this.state.article.publishedUtc).format('MMMM D, YYYY')}</div>
						<div className="helpContent">{ReactHtmlParser(this.state.article.markup)}</div>
						<div className="helpContentRating">
							{' '}
							Was this article helpful?&nbsp;&nbsp;
							{this.likeButton()} &nbsp;
							{this.dislikeButton()}&nbsp;&nbsp;
							{this.ratingText()}
						</div>
					</div>
				) : (
					<div id="centerbody width100percent">
						<h2 className="not-found">Not Found</h2>
					</div>
				)}
			</div>
		)
	}
}
export const ContentConnected = (): any => {
	const contentStateManager = container.get<IContentStateManager>('IContentStateManager')
	
	return (
		<Route 
			path="/help/pages/:name" 
			render={props => { 
				ReactGA.send({ hitType: "pageview", page: "props.location.pathname" }); 
				return <Content {...props} contentStateManager={contentStateManager} />} } />
	)
}
